import { createContext } from 'react';
import { Settings } from '~models';

export type SettingsContextType = {
    settings: Settings;
}

export const SettingsContext = createContext<SettingsContextType>({} as SettingsContextType);

export default SettingsContext;